import React from 'react'

function NoneSquareIcon() {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 55C42.6878 55 55 42.6878 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55Z"
        fill="#FA7C00"
      />
      <path
        d="M33.3787 22.2569C33.1467 22.2553 32.9237 22.3489 32.7585 22.517L22.2545 33.3585C22.0915 33.5278 22 33.7567 22 33.9953C22 34.2339 22.0915 34.4628 22.2545 34.6321C22.3358 34.7164 22.4324 34.7833 22.5388 34.8289C22.6453 34.8745 22.7594 34.898 22.8746 34.898C22.9899 34.898 23.104 34.8745 23.2104 34.8289C23.3169 34.7833 23.4135 34.7164 23.4948 34.6321L33.9924 23.7971C34.0741 23.7132 34.1389 23.6134 34.1831 23.5036C34.2273 23.3937 34.2501 23.2759 34.2501 23.157C34.2501 23.038 34.2273 22.9203 34.1831 22.8104C34.1389 22.7006 34.0741 22.6008 33.9924 22.5169C33.8288 22.3504 33.6084 22.2571 33.3787 22.2569Z"
        fill="white"
      />
      <path
        d="M19.6309 14C16.5339 14 14 16.6153 14 19.8118V36.0643C14 39.2607 16.5339 41.8675 19.6309 41.8675H35.3774C38.4744 41.8675 41 39.2607 41 36.0643V19.8118C41 16.6153 38.4744 14 35.3774 14H19.6309ZM19.6309 16.323H35.3774C37.2668 16.323 38.7493 17.8617 38.7493 19.8118V36.0643C38.7493 38.0143 37.2668 39.5445 35.3774 39.5445H19.6309C17.7415 39.5445 16.2507 38.0143 16.2507 36.0643V19.8118C16.2507 17.8617 17.7415 16.323 19.6309 16.323Z"
        fill="white"
      />
      <path
        d="M20.2138 15.0322C17.3462 15.0322 15 17.4538 15 20.4135V35.4621C15 38.4218 17.3462 40.8354 20.2138 40.8354H34.7939C37.6615 40.8354 40 38.4218 40 35.4621V20.4135C40 17.4538 37.6615 15.0322 34.7939 15.0322H20.2138ZM20.2138 17.1832H34.7939C36.5433 17.1832 37.916 18.6079 37.916 20.4135V35.4621C37.916 37.2677 36.5433 38.6845 34.7939 38.6845H20.2138C18.4644 38.6845 17.084 37.2677 17.084 35.4621V20.4135C17.084 18.6079 18.4644 17.1832 20.2138 17.1832Z"
        fill="white"
      />
    </svg>
  )
}

export default NoneSquareIcon
